import { render, staticRenderFns } from "./UpDowncard.vue?vue&type=template&id=9c6d98b0&scoped=true&"
import script from "./UpDowncard.vue?vue&type=script&lang=ts&"
export * from "./UpDowncard.vue?vue&type=script&lang=ts&"
import style0 from "./UpDowncard.vue?vue&type=style&index=0&id=9c6d98b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6d98b0",
  null
  
)

export default component.exports